import { apiPost } from './api_v2';

export async function promoteWidgetGenerationRun(runId, { signal } = {}) {
  try {
    const response = await apiPost(`/widget_generation_runs/${runId}/promote`, {}, { signal });
    const data = await response.json();

    return signal?.aborted ? null : { response, data };
  } catch (error) {
    if (signal?.aborted || error?.name === 'AbortError') return null;
    throw error;
  }
}
